<!-- use this footer if you need more control over buttons. -->
<script setup lang="ts">
import ButtonV2 from '../ButtonV2/ButtonV2.vue';
import type { ModalV2FooterButtonProps } from './modal-store';

const props = defineProps<{
  rightButtons: ModalV2FooterButtonProps[];
  leftButtons: ModalV2FooterButtonProps[];
}>();
</script>

<template>
  <div class="mt-8 flex">
    <div class="flex flex-1 gap-2">
      <ButtonV2
        v-for="button in props.leftButtons"
        :key="button.label"
        v-bind="button"
        @click="button.onClick"
      />
    </div>
    <div class="flex justify-end gap-2">
      <ButtonV2
        v-for="button in props.rightButtons"
        :key="button.label"
        v-bind="button"
        @click="button.onClick"
      />
    </div>
  </div>
</template>
